import BaseReducer from "../BaseReducer";
import CampaignAction from "./campaignAction";


export default class CampaignReducer extends BaseReducer {
  initialState = {
    campaigns: [],
    campaign: null,
    campaignStep: null,
    campaignWeeks: [],
    avatars: [],
    //posts: [],
    filteredEvents: [],
    filters: {
      type: 'USER_POST',
    },
    paginationState: {},
  };

  [CampaignAction.UPDATE_CAMPAIGN_STATE](state, action) {
    return {
      ...state,
      ...action.payload,
    };
  }

  [CampaignAction.UPDATE_CAMPAIGN_FILTERS](state, action) {
    return {
      ...state,
      filters: {...state.filters, ...action.payload},
    };
  }
}
